import { ActivitySource } from 'app/constants/activitySource'

export const getActivitySource = (source) => {
  let activitySource = ActivitySource.EMPTY

  switch (source) {
     case 0:
      activitySource = ActivitySource.EMPTY
      break
    case 1:
      activitySource = ActivitySource.NO_DATA
      break
    case 2:
      activitySource = ActivitySource.DRIVER
      break
    case 3:
      activitySource = ActivitySource.TACHOGRAPH
      break
    case 4:
      activitySource = ActivitySource.ANALOG
      break
    case 5:
      activitySource = ActivitySource.USER
      break
    case 6:
      activitySource = ActivitySource.DRIVER_1
      break
    case 7:
      activitySource = ActivitySource.DRIVER_2
      break
    case 8:
      activitySource = ActivitySource.REST
      break
    case 9:
      activitySource = ActivitySource.FILE
      break
  }

  return activitySource
}
